<template>
  <div id="doc-formato">
    <h1 class="titulo">Agora, escolha como quer enviá-lo</h1>
    <div class="documentos">
      <ul class="list-group">
        <li class="list-group-item d-flex justify-content-between align-items-center" v-on:click="nextPage(tipoDoc)">
          <div>
            <p class="txt-subtitulo">Tirar foto do documento impresso</p>
            <p class="txt-padrao">Fotos de documento digital não são aceitas</p>
          </div>
          <i class="bi bi-chevron-right"></i>
        </li>
        <li class="list-group-item d-flex justify-content-between align-items-center" v-on:click="docDigital(tipoDoc)">
          <div>
            <p class="txt-subtitulo">Usar um documento digital</p>
            <p class="txt-padrao">Ele só pode ser enviado no formato .pdf</p>
          </div>
          <i class="bi bi-chevron-right"></i>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import AppService from "../../services/AppService";

export default {
  name: "DocFormato",
  mounted() {
    this.tipoDoc = this.$store.getters.tipoDoc;
    if(this.$store.getters.tipoCaptura !== 1){
      this.$router.push({name:'Analise'});
      return;
    }
    this.$store.dispatch('setTitulo','Confirmar identidade');
    this.$store.dispatch('setLoadingStatus',false);
    this.$store.dispatch('setTipoDoc',null);
    sessionStorage.removeItem('A');
    sessionStorage.removeItem('B');
    this.appService = new AppService();
    this.appService.preLoadDocumento();
  },
  data:function (){
    return {
      tipoDoc: null,
    };
  },
  computed:{
    docs: function (){
      return  this.appService.tipoDOC()
    }
  },
  methods:{
    nextPage: function (tipoDoc){
      this.definirTipoDoc(tipoDoc);
      this.$router.push({name:'DocDigitalizacao'});
    },
    definirTipoDoc: function (tipoDoc){
      this.$store.dispatch('setTipoDoc',tipoDoc);
      sessionStorage.setItem('tipd',btoa(tipoDoc));
    },
    docDigital:function (tipoDoc){
      this.definirTipoDoc(tipoDoc);
      this.$router.push({
        name:   'DocDigital'
      });
    }
  }
}
</script>

<style scoped>
#doc-formato{
  margin-top: 80px;
}
.documentos{
  margin-top: 2rem;
}
.documentos li p{
  margin: 0;
}
.documentos ul li{
  border: 0;
  border-bottom: 1px solid #eee;
  padding: 0.1rem;
  padding-top: 1rem;
  padding-bottom: 1rem;
  cursor: pointer;
  background-color: transparent;
}
.documentos ul li:hover{
  background: rgb(255,255,255);
  background: linear-gradient(86deg, rgba(255,255,255,0) 0%, rgba(255,255,255,0) 35%, rgba(238,238,238,1) 100%);
}
.documentos ul li:last-child{
  border-bottom: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/shared/DocFormato.vue